import styled from '@emotion/styled';
import type { SetRequired } from 'type-fest';

import { createClassNames } from '@hrworks/design-system/functions';
import { overflowHyphens } from '@hrworks/design-system/utilities';

import { legacyFormGapSizeMap } from '../../functions';
import type { HelpTextProps } from './HelpText.types';

type HelpTextContainerProps = Omit<SetRequired<HelpTextProps, 'size'>, 'disabled' | 'helpText' | 'size'> & {
  $size: NonNullable<HelpTextProps['size']>;
  $disabled?: boolean;
};

const HelpTextContainer = styled.span<HelpTextContainerProps>(
  ({ theme, validationState, validationMessage, $size, $disabled }) => [
    overflowHyphens,
    {
      ...theme.eclipseTier2Typography.bodySm,
      display: 'inline-block',
      fontSize: '0.875em',
      marginTop: legacyFormGapSizeMap[$size],
      color: theme.eclipseTier2Color.text.info.default,
      ...(validationState &&
        validationMessage && {
          color: theme.eclipseTier2Color.text[validationState === 'danger' ? 'error' : validationState].default,
        }),
      ...($disabled && {
        color: theme.eclipseTier2Color.text.disabled,
      }),
    },
  ],
);

const components = { HelpTextContainer };

export const S = {
  ...components,
  ...createClassNames('HelpText', components),
} as const;
